import type { FunctionComponent } from 'react';

import type { StateT } from 'hooks/useWellbeingAgent';
import type { InsightT, TranscriptT } from 'utils';

import { type InputModeT, LeftPanel } from './LeftPanel';

import './style.scss';

type PropsT = {
  agentState: StateT;
  hideInsights?: boolean;
  initialInputMode: InputModeT;
  insights: Record<string, InsightT[]>;
  noAudioInputAfterMessageId?: string;
  transcript: TranscriptT;
};

export const ChatInterface: FunctionComponent<PropsT> = ({
  agentState,
  hideInsights,
  initialInputMode,
  insights,
  noAudioInputAfterMessageId,
  transcript,
}) => (
  <div styleName="container">
    <LeftPanel
      agentState={agentState}
      hideInsights={hideInsights}
      initialInputMode={initialInputMode}
      insights={insights}
      noAudioInputAfterMessageId={noAudioInputAfterMessageId}
      transcript={transcript}
    />
  </div>
);
